export default __webpack_public_path__ + "static/heart_yellow-61a76e6130a9bfc620b57ca178a84cd1.png";